import AddCircleIcon from "@mui/icons-material/AddCircle";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import { Grid, IconButton, Stack } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import {
  useAcceptAgentAccountMutation,
  useAgentsListQuery,
  useAllAgentsExportMutation,
  useConvertAgentToUserAccountMutation,
  useRejectAgentAccountMutation,
  useUpdateAgentsMutation,
} from "api/agents/agents.mutation";
import ExcelIcon from "assets/admin/excel.svg";
import SearchField from "components/SearchField";
import { Table } from "components/Table";
import { exportToExcel } from "constants/export";
import { handleError } from "functions/apiHandleError";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { CreateDemotionAgentModal } from "./components/createDemotionModal";
import { CreateUpdateAgentModal } from "./components/createUpdateModal";
import classes from "./style.module.scss";

const Agents = () => {
  const [searchParams] = useSearchParams();
  const paramPage = Number(searchParams.get("page")) || 1;
  const exportAgentsMutation = useAllAgentsExportMutation();

  const navigate = useNavigate();

  const [loading, setLoading] = useState();
  const [pageFilter, setPageFilter] = useState({
    page: paramPage,
    page_size: 15,
    total: 1,
    count: 0,
  });
  const [searchValue, setSearchValue] = useState("");
  const [createUpdateModal, setCreateUpdateModal] = useState({
    open: false,
    selectedAgent: null,
  });
  const [createDemotionModal, setCreateDemotionModal] = useState({
    open: false,
    selectedAgent: null,
  });

  const agentsQuery = useAgentsListQuery({
    page: pageFilter.page,
    page_size: pageFilter.page_size,
    search: searchValue,
  });
  const updateAgentsMutation = useUpdateAgentsMutation();
  const rejectAgentAccountMutation = useRejectAgentAccountMutation();
  const acceptAgentAccountMutation = useAcceptAgentAccountMutation();
  const convertAgentToUserMutation = useConvertAgentToUserAccountMutation();
  const tableData = agentsQuery.data?.results ?? [];
  const tableLoading =
    loading ||
    agentsQuery.isFetching ||
    updateAgentsMutation.isPending ||
    rejectAgentAccountMutation.isPending ||
    acceptAgentAccountMutation.isPending ||
    convertAgentToUserMutation.isPending;
  const totalPages = agentsQuery.data?.total ?? pageFilter.total;

  const updateAgentStatus = async (pk, status) => {
    setLoading(true);
    try {
      await updateAgentsMutation.mutateAsync({ agentID: pk, locked: status });
      toast.success("با موفقیت انجام شد");
    } catch (err) {
      handleError({ err });
    } finally {
      setLoading(false);
    }
  };

  const rejectAgentAccount = async (pk) => {
    setLoading(true);
    try {
      await rejectAgentAccountMutation.mutateAsync(pk);
      toast.success("با موفقیت انجام شد");
    } catch (err) {
      handleError({ err });
    } finally {
      setLoading(false);
    }
  };

  const acceptAgentAccount = async (pk) => {
    setLoading(true);
    try {
      await acceptAgentAccountMutation.mutateAsync(pk);
      toast.success("با موفقیت انجام شد");
    } catch (err) {
      handleError({ err });
    } finally {
      setLoading(false);
    }
  };

  const ConvertAgentToUserAccount = async (pk) => {
    setLoading(true);
    try {
      await convertAgentToUserMutation.mutateAsync(pk);
      toast.success("با موفقیت انجام شد");
    } catch (err) {
      handleError({ err });
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const handleExportExcel = () => {
    exportAgentsMutation.mutate(undefined, {
      onSuccess: (res) => {
        const allRows = Array.isArray(res) ? res : res?.results ?? [];

        exportToExcel(columns, allRows, "agents.xlsx");
      },
    });
  };

  const handleOpenCreateDemotionModal = (selectedAgent) => {
    setCreateDemotionModal({
      open: true,
      selectedAgent,
    });
  };

  const handleCloseCreateDemotionModal = () => {
    setCreateDemotionModal({
      open: false,
      selectedAgent: null,
    });
  };

  const handleCloseCreateUpdateModal = () => {
    setCreateUpdateModal({
      open: false,
      selectedAgent: null,
    });
  };

  useEffect(() => {
    if (pageFilter.page !== paramPage) {
      setPageFilter((prev) => ({
        ...prev,
        page: paramPage,
      }));
    }
  }, [paramPage]);

  const columns = [
    {
      field: "email",
      headerName: "ایمیل",
      minWidth: 220,
      flex: 1,
      sortable: false,
      resizable: false,
    },
    {
      field: "formatted_date_joined",
      headerName: "تاریخ عضویت",
      minWidth: 130,
      flex: 1,
      sortable: false,
      resizable: false,
      renderCell: ({ row }) => new Date(row?.formatted_date_joined).toLocaleString("fa-IR"),
    },
    {
      field: "count_applications",
      headerName: "تعداد اپلیکیشن ها",
      minWidth: 120,
      flex: 1,
      sortable: false,
      resizable: false,
    },
    {
      field: "action",
      headerName: "مدیریت حساب",
      minWidth: 200,
      flex: 1,
      sortable: false,
      resizable: false,
      hideInExport: true,
      renderCell: ({ row }) => (
        <Stack spacing={1} direction="row">
          {row?.formatted_last_login ? (
            <>
              <Tooltip title={row.locked ? "باز کردن حساب" : "بستن حساب"}>
                <IconButton
                  color={row.locked ? "success" : "error"}
                  onClick={() => updateAgentStatus(row.id, !row.locked)}
                >
                  {row.locked ? (
                    <LockOpenIcon className={classes.lockIcon} fontSize="medium" />
                  ) : (
                    <LockIcon className={classes.lockIcon} fontSize="medium" />
                  )}
                </IconButton>
              </Tooltip>
              <Tooltip title="تبدیل به کاربر">
                <IconButton color="warning" onClick={() => handleOpenCreateDemotionModal(row)}>
                  <ArrowCircleDownIcon fontSize="medium" />
                </IconButton>
              </Tooltip>
            </>
          ) : (
            <>
              <Tooltip title="تایید حساب کاربری">
                <IconButton color="success" onClick={() => acceptAgentAccount(row.id)}>
                  <ThumbUpIcon fontSize="medium" />
                </IconButton>
              </Tooltip>
              <Tooltip title="رد حساب کاربری">
                <IconButton color="error" onClick={() => rejectAgentAccount(row.id)}>
                  <ThumbDownIcon fontSize="medium" />
                </IconButton>
              </Tooltip>
            </>
          )}
        </Stack>
      ),
    },
    {
      field: "applications",
      headerName: "اپلیکیشن ها",
      minWidth: 100,
      flex: 1,
      sortable: false,
      resizable: false,
      hideInExport: true,
      renderCell: ({ row }) => (
        <Tooltip title="مشاهده اپلیکیشن ها">
          <div
            className={classes.nextBox}
            onClick={() => navigate(`/dashboard/all-files?agent=${row?.email}`)}
          >
            <ArrowBackIosNewIcon fontSize="small" />
          </div>
        </Tooltip>
      ),
    },
  ];

  return (
    <>
      <div className={classes.mainDiv}>
        <div className={classes.toolBar}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <SearchField setValueCallback={setSearchValue} variant="standard" />
            </Grid>
            <Grid item xs={0} md={4} />
            <Grid item xs={12} md={4}>
              <div className={classes.manageBar}>
                <Tooltip title="ایجاد ایجنت">
                  <IconButton
                    onClick={() => setCreateUpdateModal({ open: true, selectedAgent: null })}
                    color="success"
                  >
                    <AddCircleIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="خروجی اکسل">
                  <IconButton
                    onClick={handleExportExcel}
                    color="success"
                    disabled={exportAgentsMutation.isPending}
                  >
                    <img src={ExcelIcon} alt="export-excell" className={classes.customIcon} />
                  </IconButton>
                </Tooltip>
              </div>
            </Grid>
          </Grid>
        </div>
        <Table
          rows={tableData}
          columns={columns}
          totalPages={totalPages}
          loading={tableLoading}
          className={classes.tableContainer}
        />
      </div>
      <CreateUpdateAgentModal
        open={createUpdateModal?.open}
        onClose={handleCloseCreateUpdateModal}
        defaultData={createUpdateModal?.selectedAgent}
      />
      <CreateDemotionAgentModal
        open={createDemotionModal?.open}
        onClose={handleCloseCreateDemotionModal}
        selectedAgent={createDemotionModal?.selectedAgent}
        onConfirm={ConvertAgentToUserAccount}
      />
    </>
  );
};

export default Agents;
